import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button, IconButton, Input, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import modalStyle from '../../styles/modalStyle';
import { caseColumnDef } from '../../colDef/caseColumnDef';
import apiClient from '../../axiosClient';
import Case from '../../interfaces/case';

interface CaseUpdateModalProps {
    open: boolean;
    onClose: () => void;
    selectedRows: Case[];
}

const RemoveAgentAllocationModal: React.FC<CaseUpdateModalProps> = ({ open, onClose, selectedRows }) => {
    const handleSubmit = async () => {
        try {
            const body = selectedRows.map((row: Case) => {
                return row.agent_case_allocation_id
            }).filter((id): id is string => typeof id === 'string' && id.trim() !== ''); // we need to filter this because the user might select unassigned cases
            const response = await apiClient.delete('api/v1/agent_case_allocation', {
                data : body
            });
            if (response.status === 200) {
                alert(response.data.message);
            } else {
                alert("Remove Agent Allocation failed");
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data:' + error.response.data.message);
            } else if (error.request) {
                alert('No response received:' + error.request);
            } else {
                alert('Error message:' + error.message);
            }
        }
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography id="modal-title" variant="h6">
                        Remove Agent Allocation
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>   

                <Box mt={3}>
                    <Typography variant="subtitle1">Selected Rows:</Typography>
                    <SearchResultGrid
                        getRowId={(row) => row.case_id}
                        results={selectedRows}
                        onSelectRow={() => { }}
                        columns={caseColumnDef}
                        isRowSelectionAllowed={false}
                    />
                </Box>

                <Box mt={3} textAlign="right">
                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default RemoveAgentAllocationModal;
